import * as d3 from 'd3'
export default {

  methods: {
    
    call_Pie_Event(selection, d) {
      selection
      .on('mouseover', ()=> {+
        this.detail.forEach(dt=> {
          d3.select(`#${dt.id}_${this.localId}`).text(dt.code == 'DISC' ? d[dt.code] : d[dt.code] + '%')
        })
        // d3.select(`#RADIAL_${d.DISC}`).transition().duration(50).attr('opacity', .5)
        d3.select(`#PIE_TOTAL_${d.DISC}_${this.localId}`).transition().duration(50).attr('stroke', '#000')
        d3.select(`#PIE_ACTUAL_${d.DISC}_${this.localId}`).transition().duration(50).attr('opacity', .5)
        d3.select(`#PIE_NAME_${d.DISC}_${this.localId}`).transition().duration(50).attr('opacity', .5)

        d3.select(`#GANTT_${d.DISC}_${this.localId}`).transition().duration(50).attr('opacity', .7)
        d3.select(`#TBL_${d.DISC}_${this.localId}`).transition().duration(50).attr('opacity', .7)
      })
      .on('mouseout', ()=> {
        let data = this.rawData.find(f=> f.DISC == 'Overall')
        this.detail.forEach(dt=> {
          d3.select(`#${dt.id}_${this.localId}`)
          .attr('fill', dt.code == 'DELTA' ? this.gmx_deltaValue(data[dt.code]) : dt.code == 'DISC' ? '#000' : '#333')
          .text(dt.code == 'DISC' ? data[dt.code] : data[dt.code] + '%')
        })
        // d3.select(`#RADIAL_${d.DISC}`).transition().duration(200).attr('opacity', 1)
        d3.select(`#PIE_TOTAL_${d.DISC}_${this.localId}`).transition().duration(200).attr('stroke', d.sColor)
        d3.select(`#PIE_ACTUAL_${d.DISC}_${this.localId}`).transition().duration(200).attr('opacity', 1)
        d3.select(`#PIE_NAME_${d.DISC}_${this.localId}`).transition().duration(200).attr('opacity', 1)

        d3.select(`#GANTT_${d.DISC}_${this.localId}`).transition().duration(200).attr('opacity', 0)
        d3.select(`#TBL_${d.DISC}_${this.localId}`).transition().duration(200).attr('opacity', 0)
      }) 
      .on('click', ()=> {
        if(this.pie.key) console.log(d[this.pie.key])
      }) 
    },


    call_Link(selection, d) {

      if(!d.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(200).attr('opacity', 1)
      }) 
      .on('click', ()=> {
        
      }) 

    },

  } 
}